import { apiRequest } from "../utils/http.js";

function normaliseCreateStaffError(error) {
  const rawMessage = String(error?.message || "").trim();

  if (!rawMessage) {
    return "Failed to create staff member";
  }

  if (rawMessage.startsWith("User login already exists:")) {
    const username = rawMessage.replace("User login already exists:", "").trim();
    return `That username is already in use${username ? ` (${username})` : ""}. Please choose a different username.`;
  }

  if (rawMessage.startsWith("Staff username already exists:")) {
    const username = rawMessage.replace("Staff username already exists:", "").trim();
    return `That username is already in use${username ? ` (${username})` : ""}. Please choose a different username.`;
  }

  if (rawMessage === "This adult already has a staff record") {
    return "This adult already has a staff record.";
  }

  if (rawMessage.startsWith("Possible duplicate adult found")) {
    return "Possible duplicate adult found. Please check whether this person already exists before creating a new record.";
  }

  if (rawMessage.startsWith("Unknown staff role")) {
    return "One or more selected staff roles are not valid.";
  }

  return rawMessage;
}

export async function getWeeklyStaffScheduling(campus, weekStart) {
  const params = new URLSearchParams({
    campus,
    weekStart,
  });

  return await apiRequest(`api/staff-scheduling/weekly?${params.toString()}`);
}

export async function saveWeeklyStaffScheduling(nsrId, weekStart, dates) {
  return await apiRequest(`api/staff-scheduling/${nsrId}/week`, {
    method: "PUT",
    body: {
      weekStart,
      dates,
    },
  });
}

export async function saveWeeklyStaffSchedulingBulk(weekStartOrPayload, rowsArg) {
  const payload =
    typeof weekStartOrPayload === "object" &&
    weekStartOrPayload !== null &&
    !Array.isArray(weekStartOrPayload)
      ? {
          weekStart: weekStartOrPayload.weekStart,
          rows: weekStartOrPayload.rows || [],
        }
      : {
          weekStart: weekStartOrPayload,
          rows: rowsArg || [],
        };

  return await apiRequest("api/staff-scheduling/week", {
    method: "PUT",
    body: payload,
  });
}

export async function createStaffMember(payload) {
  try {
    return await apiRequest("api/staff-scheduling/staff", {
      method: "POST",
      body: {
        adult: {
          name: payload?.adult?.name || "",
          surname: payload?.adult?.surname || "",
          email: payload?.adult?.email || "",
          phone: payload?.adult?.phone || "",
          nationality: payload?.adult?.nationality || "",
          allergies: payload?.adult?.allergies || "",
          notes: payload?.adult?.notes || "",
        },
        staff: {
          username: payload?.staff?.username || "",
          policeCheckCompleted: Boolean(payload?.staff?.policeCheckCompleted),
          dslTrained: Boolean(payload?.staff?.dslTrained),
          firstAidQualified: Boolean(payload?.staff?.firstAidQualified),
          roles: Array.isArray(payload?.staff?.roles) ? payload.staff.roles : [],
        },
        nsr: {
          campus: payload?.nsr?.campus || "",
          arrivalDate: payload?.nsr?.arrivalDate || null,
          departureDate: payload?.nsr?.departureDate || null,
          overnightResident: Boolean(payload?.nsr?.overnightResident),
          gender: payload?.nsr?.overnightResident ? payload?.nsr?.gender || "" : "",
        },
      },
    });
  } catch (error) {
    const wrapped = new Error(normaliseCreateStaffError(error));
    wrapped.status = error?.status;
    wrapped.body = error?.body;
    throw wrapped;
  }
}